export default {
  beforeStart({ app, router, store }) {
    if (process.client) {
      // On boot start progress
      store.dispatch("startLoader");

      // On route change start progress
      router.beforeEach((to, from, next) => {
        store.dispatch("startLoader");
        next();
      });

      // On route rendered: stop
      router.afterEach(() => {
        store.dispatch("stopLoader");
      });

      // On route error: fail
      router.onError(() => {
        store.dispatch("stopLoader");
      });

      // On redirect: stop
      app.$on("router.redirect", () => {
        store.dispatch("stopLoader");
      });
    }
  },

  catchError({ store }) {
    if (process.client) {
      store.dispatch("stopLoader");
    }
  },

  // On route error: fail
  routeError({ app, store }) {
    if (process.client) {
      app.$Progress.fail();
      store.dispatch("stopLoader");
    }
  },

  // When all is ready: stop
  ready({ app, store }) {
    if (process.client) {
      app.$Progress.finish();
      store.dispatch("stopLoader");
    }
  }
};
